import apiClient from './api';

// Les routes ne prennent plus d'email : le backend agit sur l'utilisateur de la
// session. Idem pour is_external et is_admin, désormais déduits des groupes AD
// côté serveur et ignorés s'ils sont envoyés.
export const getUserInfo = () => apiClient.get(`/user/ad/info`);

export const getUser = () => apiClient.get(`/user/bdd/info`);

export const insertUser = (agency, browser) => apiClient.post(`/user/info/insert`, { agency, browser });

export const updateUser = ({ agency, browser, dark_mode, language, last_connection_at, tile_style }) => {
    const data = {};

    // Ajouter uniquement les paramètres définis pour permettre la mise à jour partielle
    if (agency !== undefined) data.agency = agency;
    if (browser !== undefined) data.browser = browser;
    if (dark_mode !== undefined) data.dark_mode = dark_mode;
    if (language !== undefined) data.language = language;
    if (last_connection_at !== undefined) data.last_connection_at = last_connection_at;
    if (tile_style !== undefined) data.tile_style = tile_style;

    return apiClient.put(`/user/info/update`, data);
};
